var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import OrgMetadataApi from '~/api/org-metadata';
const convertMetadata = (metadataDict) => {
    const orgMetadataFields = [];
    for (const [index, value] of Object.entries(metadataDict)) {
        orgMetadataFields.push({
            name: index,
            type: value.type,
            isRequired: value.isRequired,
            isMulti: value.isMulti,
            options: value.options,
            subField: value.subField,
        });
    }
    return orgMetadataFields;
};
export const getOrganizationMetadata = createAsyncThunk('organizationMetadata/get', () => __awaiter(void 0, void 0, void 0, function* () {
    const orgMetadata = yield OrgMetadataApi.get();
    return convertMetadata(orgMetadata);
}));
